import {
    Button,
    Comment,
    CommentAuthor,
    CommentContent,
    CommentGroup,
    CommentMetadata,
    CommentText,
    Divider,
    Message,
    TextArea,
} from 'semantic-ui-react'

const MAX_NOTE = 3000

export const AssetProblemNotes = ({
    isCreating,
    // creating mode
    initialValue,
    onInitialChange,
    initialError,
    // viewing/editing mode
    notes,
    noteText,
    onNoteTextChange,
    noteError,
    savingNote,
    onAddNote,
}) => {
    if (isCreating) {
        return (
            <>
                <label>Add a Note</label>
                <TextArea value={initialValue} onChange={(e, value) => onInitialChange(value.value)} />
                {initialError && <p style={{ color: 'red' }}>{initialError}</p>}
            </>
        )
    }

    return (
        <>
            {notes.length > 0 ? (
                <CommentGroup style={{ maxHeight: '16rem', overflowY: 'auto', paddingRight: '0.25rem' }}>
                    {notes.map(note => (
                        <Comment key={note.id}>
                            <CommentContent>
                                <CommentAuthor as='span'>{note.authorName || 'Unknown Author'}</CommentAuthor>
                                <CommentMetadata as='span'>
                                    {new Date(note.creationTime).toLocaleString()}
                                </CommentMetadata>
                                <CommentText>{note.text}</CommentText>
                            </CommentContent>
                        </Comment>
                    ))}
                </CommentGroup>
            ) : (
                <p style={{ color: '#666' }}>No notes yet.</p>
            )}
            <Divider />
            {noteError && <Message negative size='small'>{noteError}</Message>}
            <label>Add a Note</label>
            <TextArea
                placeholder='Add a note...'
                maxLength={MAX_NOTE}
                value={noteText}
                onChange={(_, { value }) => onNoteTextChange(value)}
                rows={3}
            />
            <div style={{ color: '#666', fontSize: '0.85em', marginTop: '0.25em', textAlign: 'right' }}>
                {noteText.length}/{MAX_NOTE} characters
            </div>
            <Button
                size='small'
                style={{ marginTop: '0.5rem' }}
                onClick={onAddNote}
                loading={savingNote}
                disabled={savingNote || !noteText.trim()}
            >
                Add Note
            </Button>
        </>
    )
}
